@if (buyer && buyer.pointSetting && currentPage === 'main-membership-status') {
  <div [ngClass]="currentPage">
    <div class="inner">
      <div class="membership-status-box">
        <div class="membership-status-top">
          <dl>
            <dt>Hi {{ buyer.firstName }}!</dt>
            <dd>Your current membership status is…</dd>
          </dl>
        </div>
        <div class="membership-status-middle">
          <div class="current-status-left">
            <div class="current-status-icon">
              <img src="/assets/images/membership/{{ buyer.pointSetting.id }}.svg" alt="" />
            </div>
          </div>
          <div class="current-status-right">
            <p class="current-level-code">{{ buyer.pointSetting.levelCode }}</p>
            <p class="current-level-name">{{ buyer.pointSetting.levelName }}</p>
            <p class="current-level-point">{{ buyer.pointSetting.pointReward }}</p>
          </div>
        </div>
        <div class="membership-status-bottom">
          <a [routerLink]="['/my/membership']" class="button-link_more"><span>Check your next quarter status</span></a>
        </div>
      </div>
    </div>
  </div>
}
@if (buyer && buyer.pointSetting && currentPage === 'my-membership-status') {
  <div [ngClass]="currentPage">
    <div class="inner">
      <div class="bar">
        <span class="membership-status" style="width: 100%">
          <p>{{ buyer.firstName }}, here is your membership status:</p>
        </span>
      </div>
      <div class="current-status-box">
        <div class="current-status-left">
          <div class="current-status-icon">
            <img src="/assets/images/membership/{{ buyer.pointSetting.id }}.svg" alt="" />
          </div>
        </div>
        <div class="current-status-right">
          This quarter status
          <p class="current-level-code">{{ buyer.pointSetting.levelCode }}</p>
          <p class="current-level-name">{{ buyer.pointSetting.levelName }}</p>
          <p class="current-level-point">({{ buyer.pointSetting.pointReward }})</p>
        </div>
      </div>
      <div class="next-month-status-box">
        <div class="next-month-status-top">Your next quarter status</div>
      </div>
      <div class="current-month-box">
        <div class="next-month-status">
          <dl>
            <dt>{{ buyer.nextMonthPointSetting.levelCode }}</dt>
            <dd>
              <span>{{ buyer.nextMonthPointSetting.levelName }} ({{ buyer.nextMonthPointSetting.point }}%)</span>
            </dd>
          </dl>
        </div>
        <div class="current-month-msi">
          <dl>
            <dt>Total MSI spend so far:</dt>
            <dd>
              <span>
                ${{ (buyer.curMsiPrice ? buyer.curMsiPrice : 0).toFixed(2) | currency: 'USD' : '' : '0.2' }}
              </span>
            </dd>
          </dl>
        </div>
        <div class="next-month-status-bar-box">
          <div class="next-month-status-bar">
            @if (buyer.curMsiPrice >= buyer.levelUpPointSetting.msiPrice) {
              <span class="msi-bar" style="width: 100%"></span>
              <span class="msi" style="right: 1px"></span>
            }
            @if (buyer.curMsiPrice < buyer.levelUpPointSetting.msiPrice) {
              <span
                class="msi-bar"
                [ngStyle]="{ width: (buyer.curMsiPrice * 100) / buyer.levelUpPointSetting.msiPrice + '%' }"
              ></span>
              <span
                class="msi"
                [ngStyle]="{
                  right: 'calc(100% - ' + (buyer.curMsiPrice * 100) / buyer.levelUpPointSetting.msiPrice + '% + 1px)',
                }"
              ></span>
            }
            <span class="caption"
              >Level up to
              <p>{{ buyer.levelUpPointSetting.levelName }} ({{ buyer.levelUpPointSetting.point }}%)</p>
              <br />by ordering an additional [
              <p>
                ${{
                  (buyer.levelUpPointSetting.levelUpPrice ? buyer.levelUpPointSetting.levelUpPrice : 0).toFixed(2)
                    | currency: 'USD' : '' : '0.2'
                }}
              </p>
              ]</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
}
